/* global femcare */

femcare.product.standaloneReview = {
    init: function () {
        var isBVLoaded = window.$BV;
        var isPowerReviewsLoaded = window.POWERREVIEWS;

        if(isPowerReviewsLoaded){
            var pr_render_options = window.pr_render_options || [];
            window.POWERREVIEWS.display.render(pr_render_options);
        }

        $('.product-list--reviews .product-list__item').on('click', function () {
            var productEan = this.getAttribute('data-product-ean');

            if (isBVLoaded) {
                window.$BV.ui('rr', 'submit_review', { productId: productEan });
            } else if (isPowerReviewsLoaded) {
                var merchantId = window.powerreviewsSubmitInfo.merchantId;
                var locale = window.powerreviewsSubmitInfo.locale;
                window.open('https://ui.powerreviews.com/stable/standalone.html?pageId=' + productEan + '&merchantId=' + merchantId + '&pr_locale=' + locale, '_blank');
            }

            return false;
        });
    }
};

